import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import swal from 'sweetalert';
import {
	getOfficialSourceAdmin, createOfficialSource, updateOfficialSource,
} from '../../../api/contentAdminApi';
import { CmsFormShell } from './CmsFormFields';

const EMPTY = {
	name: '', slug: '', url: '', department: '', source_type: 'government',
	last_verified_at: '', notes: '', published: true,
};

export default function OfficialSourceAdminForm() {
	const { slug } = useParams();
	const history = useHistory();
	const isEdit = Boolean(slug);
	const [form, setForm] = useState(EMPTY);
	const [saving, setSaving] = useState(false);

	useEffect(() => {
		if (!isEdit) return;
		getOfficialSourceAdmin(slug)
			.then((res) => setForm({ ...EMPTY, ...(res.data?.official_source || res.data) }))
			.catch(() => swal('Error', 'Could not load source', 'error'));
	}, [isEdit, slug]);

	const onChange = (key, value) => setForm((f) => ({ ...f, [key]: value }));

	const handleSubmit = async (e) => {
		e.preventDefault();
		setSaving(true);
		try {
			if (isEdit) await updateOfficialSource(slug, form);
			else await createOfficialSource(form);
			swal('Saved', 'Official source saved.', 'success');
			history.push('/admin/cms/official_sources');
		} catch (err) {
			swal('Error', err.response?.data?.errors?.[0] || 'Could not save', 'error');
		} finally {
			setSaving(false);
		}
	};

	return (
		<CmsFormShell title={isEdit ? `Edit: ${form.name}` : 'New official source'} backHref="/admin/cms/official_sources" onSubmit={handleSubmit} saving={saving}>
			<fieldset className="admin-cms-form__section">
				<legend>Source details</legend>
				<div className="admin-cms-form__row">
					<label><span>Name</span><input required value={form.name} onChange={(e) => onChange('name', e.target.value)} /></label>
					<label><span>Slug</span><input required value={form.slug} onChange={(e) => onChange('slug', e.target.value)} disabled={isEdit} /></label>
				</div>
				<label><span>Official URL</span><input required type="url" value={form.url} onChange={(e) => onChange('url', e.target.value)} /></label>
				<div className="admin-cms-form__row">
					<label><span>Department</span><input value={form.department || ''} onChange={(e) => onChange('department', e.target.value)} /></label>
					<label>
						<span>Type</span>
						<select value={form.source_type} onChange={(e) => onChange('source_type', e.target.value)}>
							{['government', 'embassy', 'park_authority', 'airline', 'operator', 'other'].map((t) => (
								<option key={t} value={t}>{t.replace(/_/g, ' ')}</option>
							))}
						</select>
					</label>
				</div>
				<label><span>Last verified</span><input type="date" value={form.last_verified_at ? String(form.last_verified_at).slice(0, 10) : ''} onChange={(e) => onChange('last_verified_at', e.target.value)} /></label>
				<label><span>Notes</span><textarea rows={3} value={form.notes || ''} onChange={(e) => onChange('notes', e.target.value)} /></label>
				<label className="admin-cms-form__check">
					<input type="checkbox" checked={!!form.published} onChange={(e) => onChange('published', e.target.checked)} /> Published
				</label>
			</fieldset>
		</CmsFormShell>
	);
}
